module.exports = __webpack_public_path__ + "assets/img/driver-btn-5d8408bb.png";